import { render, staticRenderFns } from "./edit-appointment.vue?vue&type=template&id=7df68da9&scoped=true"
import script from "./edit-appointment.vue?vue&type=script&lang=js"
export * from "./edit-appointment.vue?vue&type=script&lang=js"
import style0 from "./edit-appointment.vue?vue&type=style&index=0&id=7df68da9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df68da9",
  null
  
)

export default component.exports